import app from "nystem";
import { useEffect, useRef } from "react";
import weatherFeed from "../../client/weatherFeed";

const MapWeatherFetcher = ({ model, value, view }) => {
  const feed = useRef();
  const current = useRef(value);
  current.current = value;
  useEffect(() => {
    const apiKey = model.apiKey || app.settings.weatherApiKey || "fedf33dfd3ad1d89e2fc4a5e641ac6b6";
    feed.current = weatherFeed({ app, view, model, value: current.current, apiKey });
    return () => { feed.current.destroy(); feed.current = undefined; };
  }, [model, view]);
  useEffect(() => { if (model.fromPoint) feed.current?.setPoint(value); }, [value, model.fromPoint]);
  return null;
};

export default MapWeatherFetcher;
